import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Components
import TestimonialBox from "../Elements/TestimonialBox";

export default function TestimonialSlider() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <Slider {...settings}>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="nFinity Solutions transformed our outdated system into a fast, scalable platform. Their team understood our needs clearly and delivered beyond expectations. We finally have a digital system we can rely on."
            author="Nasir Iqbal, Manager MIS Lahore Waste Management Company"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="nFinity Solutions provided exceptional mobile development talent through their staff augmentation model. Their expertise and seamless collaboration significantly accelerated our project delivery."
            author="Muhammad Fahad Khan, Founder & Owner, Omnicode Technologies"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="Working with nFinity Solutions was a seamless experience—their team delivered our TrukitEasy product with precision, speed, and strong technical expertise. Their commitment to quality and smooth communication made the entire development journey exceptional"
            author="TrukitEasy"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="nFinity Solutions turned our vision for Rapairly into a fully functional, high-quality product. Their professionalism, technical skill, and timely delivery exceeded our expectations."
            author="Taifoor Abbas, Rapairly Product Owner"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="The agentic AI solutions provided by nFinity Solutions exceeded our expectations. Their autonomous systems manage complex operations with accuracy and efficiency, significantly improving productivity."
            author="Aisha R., Product Manager, FinEdge"
          />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <TestimonialBox
            text="nFinity Solutions provided skilled developers who seamlessly integrated with our in-house team. Their staff augmentation services helped us scale quickly and deliver projects efficiently."
            author="Shahid Anwar, CTO Tech About"
          />
        </LogoWrapper>
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 90%;
  padding: 0 5%;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
